import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import PaperFragment from "../misc/PaperFragment";

export default function UnexpectedError(props) {
    const message = props?.error?.message ?? "Something went wrong.";
    const imgSrc = `${process.env.PUBLIC_URL}/images/signout.jpeg`;

    return (
        <Box sx={{ mt: 4, textAlign: "center" }}>
            <Typography variant="h5" gutterBottom>
                Unexpected error
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {message}
            </Typography>
            <Link to="/" className="text-link">
                <Button onClick={props.resetErrorBoundary}>Back to menu</Button>
            </Link>
            <PaperFragment center value={<img src={imgSrc} alt="Unexpected error" width="50%" />} />
        </Box>
    );
}
